import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import generateClassesFromMap from '@insight/toolkit-utils/lib/generators/generateClassesFromMap';
import { STAR_RATING_SIZES, STAR_RATING_CLASS_MAP } from './classes';

import AverageRating from './AverageRating';
import Star from './Star';

// Stateful Component To prevent useless rerenders from the
// onClick handler

export default class StarRating extends Component {
  state = {
    selectedRating: 0,
  };
  onStarClick = ({ target: { value } }) => {
    this.props.onStarClick(value);
    this.setState({ selectedRating: value });
  };

  renderEditableStars = () => {
    const stars = [];
    for (let i = 1; i <= this.props.stars; i++) {
      stars.push(
        <Star
          editable={true}
          index={i}
          key={`star-${i}`}
          onClick={this.onStarClick}
        />
      );
    }
    return stars;
  };

  renderNonEditableStars() {
    const { rating, stars } = this.props;
    // Get the number of whole stars
    const fixedRating = Math.floor(rating);
    const fraction = rating - fixedRating;
    const isRatingFloat = 0.9 >= fraction && fraction >= 0.5;
    let nonEditableStars = [];
    for (let i = 0; i < stars; i++) {
      let fillType = i + 1 <= fixedRating ? 'full' : 'outline';
      // do you need half star?
      if (isRatingFloat && i === fixedRating) {
        fillType = 'half';
      }
      nonEditableStars.push(
        <Star
          editable={false}
          fillType={fillType}
          index={i}
          key={`star-${i}`}
        />
      );
    }
    return nonEditableStars;
  }

  render() {
    const {
      averageClassName,
      containerClassName,
      editable,
      rating,
      size,
      showAverage,
      stars,
    } = this.props;
    const { selectedRating } = this.state;
    const displaystars = editable
      ? this.renderEditableStars()
      : this.renderNonEditableStars();
    const derivedClasses = generateClassesFromMap(
      { size },
      STAR_RATING_CLASS_MAP
    );
    const classes = cn(
      'c-star-rating',
      derivedClasses,
      {
        'c-star-rating--static': !editable,
        'c-star-rating--editable': editable && selectedRating === 0,
      },
      containerClassName
    );
    const averageClasses = cn('c-star-rating__average', averageClassName);

    return (
      <Fragment>
        <div className={classes}>{displaystars}</div>
        {showAverage && (
          <AverageRating
            className={averageClasses}
            rating={rating}
            stars={stars}
          />
        )}
      </Fragment>
    );
  }
}

// TODO: Give better prop validation for rating.
// As in, rating should be required if it is not editable, etc.
StarRating.propTypes = {
  averageClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  editable: PropTypes.bool,
  onStarClick: PropTypes.func,
  rating: PropTypes.number,
  size: PropTypes.oneOf(STAR_RATING_SIZES),
  showAverage: PropTypes.bool,
  stars: PropTypes.number,
};

StarRating.defaultProps = {
  averageClassName: '',
  containerClassName: '',
  editable: false,
  rating: 0,
  showAverage: false,
  stars: 5,
};
